import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import type { RootState } from "../../store";

const SuperAdminRoute = () => {
  const superAdmin = useSelector((state: RootState) => (state as any).superAdminAuth?.superAdmin);

  if (!superAdmin) {
    return <Navigate to="/superadmin/login" replace />;
  }

  return <Outlet />;
};

export default SuperAdminRoute;
